import { addMailboxToTrustedSendersList } from 'owa-mail-triage-action/lib/actions/actionCreators/addToSafeSenders';
import { mutator } from 'satcheljs';

/**
 * Push mailbox to the end of the junkEmailConfiguration.TrustedSendersAndDomains list
 */
mutator(addMailboxToTrustedSendersList, actionMessage => {
    actionMessage.junkEmailConfiguration.TrustedSendersAndDomains.push(
        actionMessage.mailbox.EmailAddress
    );
});
